import { styled } from 'theme'

export const StyledRealEstateSettingsHelp = styled.div`
  background-color: white;
  padding: 1rem;
  width: 50em;
  margin: 0 auto;
`
